import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import NotFound from '../views/NotFound.vue'
import MenuDetail from '../views/MenuDetail.vue'
import News from '../views/News.vue'
import NewsDetail from '../views/NewsDetail.vue'
import Assets from '../views/Assets.vue'
import Party from '../views/Party.vue'
import PartyList from '../views/PartyList.vue'
import Careers from '../views/Careers.vue'
import AuctionDetail from '../views/AuctionDetail.vue'
import PropertyDetail from '../views/PropertyDetail.vue'
import Search from '../views/Search.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '首页' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: '关于我们' }
  },
  {
    path: '/news',
    name: 'News',
    component: News,
    meta: { title: '资讯中心' }
  },
  {
    path: '/news/detail',
    name: 'NewsDetail',
    component: NewsDetail,
    meta: { title: '资讯详情' }
  },
  {
    path: '/assets',
    name: 'Assets',
    component: Assets,
    meta: { title: '资产专区' }
  },
  {
    path: '/auction/detail',
    name: 'AuctionDetail',
    component: AuctionDetail,
    meta: { title: '在拍资产详情' }
  },
  {
    path: '/property/detail',
    name: 'PropertyDetail',
    component: PropertyDetail,
    meta: { title: '资产详情' }
  },
  {
    path: '/party',
    name: 'Party',
    component: Party,
    meta: { title: '企业党建' }
  },
  {
    path: '/party/list',
    name: 'PartyList',
    component: PartyList,
    meta: { title: '党建资讯列表' }
  },
  {
    path: '/careers',
    name: 'Careers',
    component: Careers,
    meta: { title: '人才招聘' }
  },
  {
    path: '/careers/detail/:id',
    name: 'CareersDetail',
    component: () => import('../views/CareersDetail.vue'),
    meta: { title: '招聘详情' }
  },
  {
    path: '/menu/:id',
    name: 'MenuDetail',
    component: MenuDetail,
    meta: { title: '菜单详情' }
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
    meta: { title: '404' }
  },
  {
    path: '/search',
    name: 'Search',
    component: Search,
    meta: { title: '全文检索' }
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 }
  }
})

import store from '@/store'

router.beforeEach((to, from, next) => {
  const siteTitle = store.state.siteConfig.showTitle || '辽宁资产管理有限公司'
  const pageTitle = to.meta.title
  document.title = pageTitle ? `${pageTitle} - ${siteTitle}` : siteTitle
  next()
})

export default router
